// src/components/PhilosophyIntro.js

import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const PhilosophyIntro = () => {
  return (
    <Box
      component="section"
      sx={{
        backgroundColor: '#f1f1f1', // Stone White
        py: { xs: 8, md: 12 },    // Creates the 'spacious' vertical rhythm
        textAlign: 'center',
      }}
    >
      <Container maxWidth="md">
        {/* The Section Heading */}
        <Typography
                      variant="h3"
                      component="h2"
                      sx={{
                        fontWeight: 500,
                        mb: 3,
                        lineHeight: 1.3,
                        fontFamily: 'serif',
                        color:'#005F69'
                      }}
                    >
          Curated by Experts, Crafted for You
        </Typography>

        {/* The Philosophy Paragraph */}
        <Typography
          variant="h6" // Using h6 gives it a slightly more substantial feel than body1
          component="p"
          sx={{
            fontFamily: '"Lato", "Helvetica", "Arial", sans-serif',
            fontWeight: 400,
            color: 'text.secondary',
            lineHeight: 1.8, // Increased line height is key for readability of centered text
            maxWidth: '750px', // Crucial for readability; prevents lines from being too wide
            mx: 'auto',       // Centers the constrained-width paragraph
          }}
        >
          At  Bella Ceylon Voyages, we believe travel should be transformative. These experiences are not rigid itineraries; they are handcrafted starting points, built around the themes that make Sri Lanka unforgettable. Whether you seek ancient history, wild adventure, or serene tranquility, your perfect journey begins here. Let's start the conversation.
        </Typography>
      </Container>
    </Box>
  );
};

export default PhilosophyIntro;